// removed by extract-text-webpack-plugin
module.exports = {"companyContactUs":"_2qymkUwlbs7P5dZVo5hLBg","subtitle":"J5x7WisAxFsyGlaN5PGbA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Company/CompanyContactUs/BrokerContactUs/BrokerContactUs.scss
// module id = 1570
// module chunks = 0